import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UpSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/UpSquareTwoTone";
import AntdIcon from "../components/AntdIcon";
var UpSquareTwoTone = function UpSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpSquareTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UpSquareTwoTone.displayName = 'UpSquareTwoTone';
}
export default /*#__PURE__*/React.forwardRef(UpSquareTwoTone);